<template>
  <div class="rounded_10 p-2 position-relative mb-4" :class="[{ disabledContent: !isLastIndex, 'bg-light-1': !isGradient, 'transparent-bgcolor-light': isGradient }]
    ">
    <div class="calendar-container">
      <div class="header">
        <button @click="goToPreviousMonth" class="btn shadow-none"
          :class="[{ 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light text-white': isGradient }]">
          <em class="primaryicon-left-arrow-light"></em></button>
        <h5 class="m-0 font-weight-bold" :class="[{ 'text-white': isGradient }]">{{ monthNames[currentMonth]
        }} {{ currentYear }}</h5>
        <button class="btn shadow-none" @click="goToNextMonth"
          :class="[{ 'shadow-sm bg-white  ': !isGradient, 'transparent-bgcolor-light text-white': isGradient }]"><em
            class="primaryicon-right-arrow-light"></em></button>
      </div>

      <div class="weekdays">
        <div v-for="day in weekDays" :key="day" class="day-name" :class="[{ 'text-white': isGradient }]"> {{ day }}
        </div>
      </div>

      <div class="days">
        <div v-for="blank in blankDays" :key="'b' + blank" class="day blank"></div>
        <div v-for="day in daysInMonth" :key="day" class="day font-weight-bold cursor-pointer"
          @click="isDateAvailable(day) ? selectDay(day) : null"
          :style="{ backgroundColor: selectedDay === day ? (isGradient ? '#fff' : primaryColor) : '', color: selectedDay === day ? (isGradient ? '#000' : '#fff') : '' }"
          :class="[
            { 'disabled-day': !isDateAvailable(day) },
            { 'bg-white': !isGradient && selectedDay !== day },
            { 'transparent-bgcolor-light text-white': isGradient && selectedDay !== day }
          ]">
          {{ day }}
        </div>
      </div>

      <div v-if="selectedDay">
        <h6 class="my-3 font-weight-normal" :class="[{ 'text-white': isGradient }]">
          Showing available times for {{ monthNames[currentMonth] }} {{ selectedDay }}
        </h6>

        <div class="time_slots">
          <VSlickCarousel ref="slick" class="service__types__list px-3" v-bind="slickOptions">
            <template #nextArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow"
                :style="getArrowStyles('right')"></em>
            </template>
            <div v-for="(time, index) in availableTimeSlots" :key="index" class="each_slot"
              @click="selectTimeSlot(index, time)" :style="{
                backgroundColor: selectedTimeSlotIndex === index ? (isGradient ? '#fff' : primaryColor) : '',
                color: selectedTimeSlotIndex === index ? (isGradient ? '#000' : '#fff') : ''
              }" :class="[
                { 'shadow-sm bg-white': !isGradient && selectedTimeSlotIndex !== index },
                { 'transparent-bgcolor-light text-white': isGradient && selectedTimeSlotIndex !== index }
              ]">
              <p class="m-0 font-weight-bold">{{ time }}</p>
            </div>
            <template #prevArrow="arrowSlotProps">
              <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow"
                :style="getArrowStyles('left')"></em>
            </template>
          </VSlickCarousel>
        </div>
      </div>
      <div v-else class="min_height-100">
        <h6 class="my-3 font-weight-normal" :class="[{ 'text-white': isGradient }]">
          Please select a date to see available times.
        </h6>
      </div>

      <!-- <div v-if="selectedDay && selectedTimeValue" class="mt-4 selected-info" :class="[{ 'text-white': isGradient }]">
        <h6 class="font-weight-bold">Selected Date & Time:</h6>
        <p>{{ monthNames[currentMonth] }} {{ selectedDay }}, {{ currentYear }} at {{ selectedTimeValue }}</p>
      </div> -->
    </div>
    <div v-if="isApiLaoding"
      class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center rounded_10 "
      style="background-color: rgba(0, 0, 0, 0.5); z-index: 999;">
      <div class="spinner-border bg-white d-flex align-items-center justify-content-center p-3 rounded_10 ">
        <!-- <tvm-pre-loader /> -->
        <AssistantIcon :auto-spin="true" :spin-duration="500" />
      </div>
    </div>
  </div>
</template>

<script setup>
import TvmPreLoader from "./../../TvmPreLoader/TvmPreLoader.vue";
import AssistantIcon from "../Icons/AssistantIcon.vue";
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import { ref, computed, onMounted } from 'vue'
import axios from 'axios';
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
const slickOptions = {
  infinite: false,
  slidesPerGroup: 3,
  groupsToShow: 7,
  dots: false,
  ignorePrefersReducedMotion: true
};
const primaryColor = window.primaryColor;
const today = new Date()
const currentYear = ref(today.getFullYear())
const currentMonth = ref(today.getMonth())
const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const availableDates = ref([]);
const availableTimeSlots = ref([]);
const selectedDay = ref(null);
const selectedTimeSlotIndex = ref(null);
const selectedTimeValue = ref(null);
const isApiLaoding = ref(false);

const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const daysInMonth = computed(() => {
  const days = new Date(currentYear.value, currentMonth.value + 1, 0).getDate()
  return Array.from({ length: days }, (_, i) => i + 1)
})

const blankDays = computed(() => {
  const firstDay = new Date(currentYear.value, currentMonth.value, 1).getDay()
  return Array.from({ length: firstDay })
})

const isGradient = computed(() => {
  return props.chatThemeSettings?.isGradient ?? false
})

const startOfMonthVal = computed(() => {
  return new Date(currentYear.value, currentMonth.value, 1);
});

const endOfMonthVal = computed(() => {
  return new Date(currentYear.value, currentMonth.value + 1, 0);
});

const responseData = computed(() => {
  return props.botResponse?.component?.value || {};
});



const props = defineProps({
  isLastIndex: {
    type: Boolean,
    default: true
  },
  chatThemeSettings: {
    type: Object,
    default: () => ({})
  },
  botResponse: {
    type: Object,
    default: () => ({})
  }
});

function selectDay(day) {
  selectedDay.value = day;
  selectedTimeSlotIndex.value = null; // Reset time selection when date changes
  selectedTimeValue.value = null;
  const selectedDate = availableDates.value.find((date) => date.day === day);
  availableTimeSlots.value = selectedDate ? selectedDate.timeSlots : [];

  if (availableTimeSlots.value?.length > 20) {
    slickOptions.slidesPerGroup = 3;
  } else {
    slickOptions.slidesPerGroup = 2;
  }
}

function selectTimeSlot(index, time) {
  if (!selectedDay.value) {
    console.warn("Please select a date first.");
    return;
  }
  selectedTimeSlotIndex.value = index;
  selectedTimeValue.value = time;


  try {
    let selectedDateAndTime = `${selectedDay.value} ${monthNames[currentMonth.value]} ${currentYear.value}  ${selectedTimeValue.value}`;
    ChatWidgetService.postTvmMessage(selectedDateAndTime, null, props.botResponse?.component?.submitFlow,
      props.botResponse?.component?.submitAction);
  } catch (error) {
    cosole.log(error);
  }


}

function goToPreviousMonth() {
  if (currentMonth.value === 0) {
    currentMonth.value = 11
    currentYear.value--
  } else {
    currentMonth.value--
  }
  selectedDay.value = null; // Reset selection when month changes
  selectedTimeSlotIndex.value = null;
  selectedTimeValue.value = null;
  if (today.getMonth() === currentMonth.value && today.getFullYear() === currentYear.value) {
    getDateTimeSlots(
      new Date(today.toDateString()),
      new Date(endOfMonth.toDateString())
    );
  } else {
    getDateTimeSlots(
      new Date(startOfMonthVal.value.toDateString()),
      new Date(endOfMonthVal.value.toDateString())
    );
  }
}

function goToNextMonth() {
  if (currentMonth.value === 11) {
    currentMonth.value = 0
    currentYear.value++
  } else {
    currentMonth.value++
  }
  selectedDay.value = null;
  selectedTimeSlotIndex.value = null;
  selectedTimeValue.value = null;
  console.log(currentMonth.value)
  if (today.getMonth() === currentMonth.value && today.getFullYear() === currentYear.value) {
    getDateTimeSlots(
      new Date(today.toDateString()),
      new Date(endOfMonth.toDateString())
    );
  } else {
    getDateTimeSlots(
      new Date(startOfMonthVal.value.toDateString()),
      new Date(endOfMonthVal.value.toDateString())
    );
  }
}

function getArrowStyles(direction) {
  const commonStyles = {
    cursor: 'pointer',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: isGradient.value ? 'rgba(0,0,0,0.5)' : primaryColor, // Use isGradient.value
    color: '#fff',
    fontSize: '10px',
    padding: '5px 15px !important',
    zIndex: 10,
    height: '95%'
  };
  if (direction === 'left') {
    return {
      ...commonStyles,
      left: '-40px !important',
      borderRadius: '3px',
    };
  } else if (direction === 'right') {
    return {
      ...commonStyles,
      right: '-40px !important',
      borderRadius: '3px',
    };
  }
  return commonStyles;
}

function getDateTimeSlots(startDate, endDate) {
  try {
    isApiLaoding.value = true;
    axios.post(`${window.chatWidgetApiBaseUrl}/api/AssistantServices/getcalenderinfo`, {
      ...props.botResponse.component.value,
      startDate: startDate,
      endDate: endDate
    })
      .then(response => {
        if (response.data && response.data.length > 0) {
          // Process the response data as needed
          console.log("Available time slots:", response.data);
          availableDates.value = response.data || [];
          isApiLaoding.value = false;
          if (responseData.value?.appointmentDay) {
            selectDay(responseData.value?.appointmentDay);
          }
        } else {
          console.warn("No available time slots found for the selected date.");
          isApiLaoding.value = false;
        }
      })
      .catch(error => {
        console.error("Error fetching time slots:", error);
        isApiLaoding.value = false;
      });
  } catch (error) {

  }
}

function isDateAvailable(day) {
  return availableDates.value.some((date) => date.day === day);
}


onMounted(() => {
  if (responseData.value.startDate && responseData.value.endDate) {
    currentYear.value = new Date(responseData.value.startDate).getFullYear();
    currentMonth.value = new Date(responseData.value.startDate).getMonth();
    getDateTimeSlots(
      new Date(responseData.value.startDate),
      new Date(responseData.value.endDate)
    );
  } else {
    getDateTimeSlots(
      new Date(startOfMonthVal.value.toDateString()),
      new Date(endOfMonthVal.value.toDateString())
    );
  }
});

</script>

<style scoped>
.calendar-container {
  max-width: 800px;
  margin: auto;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.header .btn {
  height: 30px;
  width: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.header em {
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}

.weekdays,
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
}

.weekdays {
  margin-top: 10px;
}

.days {
  margin-top: 10px;
}

.day-name,
.day {
  padding: 7px 10px;
  border: 0px solid #ddd;
  width: 100px;
  border-radius: 10px;
}

.blank {
  background-color: transparent;
  border: none;
}

.each_slot {
  border-radius: 8px;
  cursor: pointer;
  padding: 12px 5px;
  margin: 5px;
}

.each_slot p {
  font-size: 13px !important;
}

.bg-light-1 {
  background: #ececec;
}



.cursor-pointer {
  cursor: pointer;
}

.selected-info {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  margin-top: 20px;
  background-color: #f9f9f9;
}

.selected-info.text-white {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

.bg-light-1 .selected-info {
  background-color: #fff;
}

.transparent-bgcolor-light .selected-info {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: rgba(0, 0, 0, 0.1);
}

.disabledContent .day,
.disabledContent .each_slot {
  pointer-events: none;
  opacity: 0.7;
}

.min_height-100 {
  min-height: 170px;
}

.disabled-day {
  pointer-events: none;
  opacity: 0.5;
}
</style>
